export enum EStatusDFe {
    Pendente = 1,
    AguardandoReenvio = 2,
    Rejeitado = 3,
    EmitidoEmContigencia = 4,
    Autorizado = 5,
    Cancelado = 6
}
